module.exports = __webpack_public_path__ + "img/workspace-reservation.356f4b8b.svg";